import { Pipe, PipeTransform } from '@angular/core'
import { ScoreConfiguration } from '@mmx/shared'

@Pipe({
  name: 'questionLabel',
  pure: true,
  standalone: false,
})
export class QuestionLabelPipe implements PipeTransform {
  public transform(text: string, input: { value: any, scorer: ScoreConfiguration }): string {
    const showAnswerScore = input.scorer?.showAnswerScore ?? false
    const score = showAnswerScore ? input?.scorer?.scores[input.value] ?? 0 : null

    return score != null ? `${score} - ${text}` : text
  }
}
